import { useCallback } from 'react';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { createCoinsCheckoutSession } from '../helpers/coinsApi';

export type PurchaseBundleResult = {
  success: boolean;
  awarded?: number;
  coins?: number;
  error?: string;
  redirecting?: boolean;
};

export function usePurchaseBundle() {
  const apiClient = useApiClient();

  const purchaseBundle = useCallback(async (bundleId: string): Promise<PurchaseBundleResult> => {
    try {
      const { url } = await createCoinsCheckoutSession(
        apiClient as (endpoint: string, options?: Record<string, unknown>) => Promise<{ status: number; data: unknown }>,
        bundleId,
      );
      // Redirect to Stripe Checkout — user returns via success URL with ?coinsPurchased=true
      if (typeof window !== 'undefined') {
        window.location.href = url;
      }
      return { success: false, redirecting: true };
    } catch (err: unknown) {
      return { success: false, error: err instanceof Error ? err.message : 'Purchase failed' };
    }
  }, [apiClient]);

  // No-op on web — coins are credited via Stripe (checkout webhook + sync), not RevenueCat.
  const reconcileCoins = useCallback(async (): Promise<number> => 0, []);

  return { purchaseBundle, reconcileCoins };
}
